// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminAuctions = (client) => ({
    /**
     * `POST /admin/auctions/:id/cancel`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdCancel
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/cancel/route.ts
     */
    cancel: (id, body, query, headers) => client.fetch(buildPath("/admin/auctions/:id/cancel", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/auctions`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsCreate
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/auctions", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/auctions/:id/bids`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdBidsCreate
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/bids/route.ts
     */
    createBid: (id, body, query, headers) => client.fetch(buildPath("/admin/auctions/:id/bids", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/auctions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdDelete
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/admin/auctions/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /admin/auctions/:id/bids/:bidId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdBidsBididDelete
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/bids/[bidId]/route.ts
     */
    deleteBid: (id, bidId, body, query, headers) => client.fetch(buildPath("/admin/auctions/:id/bids/:bidId", [id, bidId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/auctions`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsList
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/route.ts
     */
    list: (query, headers) => client.fetch("/admin/auctions", { method: "GET", query, headers }),
    /**
     * `GET /admin/auctions/:id/bids`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdBidsRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/bids/route.ts
     */
    listBids: (id, query, headers) => client.fetch(buildPath("/admin/auctions/:id/bids", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/auctions/:id/earnest-participations`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdEarnestParticipationsRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/earnest-participations/route.ts
     */
    listEarnestParticipations: (id, query, headers) => client.fetch(buildPath("/admin/auctions/:id/earnest-participations", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/auctions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/auctions/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/auctions/:id/bids/:bidId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdBidsBididRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/bids/[bidId]/route.ts
     */
    retrieveBid: (id, bidId, query, headers) => client.fetch(buildPath("/admin/auctions/:id/bids/:bidId", [id, bidId]), { method: "GET", query, headers }),
    /**
     * `POST /admin/auctions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdUpdate
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/auctions/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/auctions/:id/bids/:bidId/earnest-money`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdBidsBididEarnestMoneyCreate
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/bids/[bidId]/earnest-money/route.ts
     */
    updateBidsEarnestMoney: (id, bidId, body, query, headers) => client.fetch(buildPath("/admin/auctions/:id/bids/:bidId/earnest-money", [id, bidId]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/auctions/:id/earnest-participation`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionsIdEarnestParticipationCreate
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auctions/[id]/earnest-participation/route.ts
     */
    updateEarnestParticipation: (id, body, query, headers) => client.fetch(buildPath("/admin/auctions/:id/earnest-participation", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=auctions.js.map